import React from "react";
import { Flex, Span } from "@catchoftheday/cg-components";
import { StarRatings } from "../StarRatings/StarRatings";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ListFacetOption = function ListFacetOption(_ref) {
  var id = _ref.id,
      value = _ref.value,
      displayName = _ref.displayName,
      count = _ref.count,
      selected = _ref.selected,
      onChange = _ref.onChange,
      isStarRating = _ref.isStarRating,
      InputComponent = _ref.InputComponent;
  var rating = parseInt(displayName, 10);
  return ___EmotionJSX(Flex, {
    alignItems: "center"
  }, ___EmotionJSX(Flex, {
    as: "label",
    alignItems: "center"
  }, ___EmotionJSX(InputComponent, {
    id: id,
    name: value,
    value: value,
    inputContainerProps: {
      mr: 2
    },
    onChange: onChange,
    checked: selected
  }), isStarRating && !isNaN(rating) ? ___EmotionJSX(StarRatings, {
    rating: rating
  }) : ___EmotionJSX(Span, null, displayName), ___EmotionJSX(Span, {
    color: "typography.inactive",
    display: "inline-block",
    ml: 2
  }, "(", count, ")")));
};